import request from '@/utils/request'

/**
 * 根据组织ID(或者部门ID)和设备子类型，获取下属的学校（点位）-食堂-设备关系列表(用途：组织人员页面-获取晨检机列表)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptDotorgdeptTcListGet(data) {
  return request({
    type: 'device',
    url: 'dept/dotorgdept/tc/list/get',
    method: 'post',
    data
  })
}

/**
 * 添加设备
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceAdd(data) {
  return request({
    type: 'device',
    url: 'device/add',
    method: 'post',
    data
  })
}

/**
 * 24小时空气质量变化
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceAirQuality24Get(data) {
  return request({
    type: 'device',
    url: 'device/air/quality/24/get',
    method: 'post',
    data
  })
}

/**
 * 食堂24小时空气质量变化
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceAirQuality24GetDept(data) {
  return request({
    type: 'device',
    url: 'device/air/quality/24/get/dept',
    method: 'post',
    data
  })
}

/**
 * 业务数据中心 大数据分析 能耗分析报表 24H耗电量趋势（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceBaseStatisticAnalyse24hTrendGet(data) {
  return request({
    type: 'device',
    url: 'device/base/statistic/analyse/24h/trend/get',
    method: 'post',
    data
  })
}

/**
 * 业务数据中心 大数据分析 能耗分析报表 左侧今天统计（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceBaseStatisticAnalyseBaseStatisticGet(data) {
  return request({
    type: 'device',
    url: 'device/base/statistic/analyse/base/statistic/get',
    method: 'post',
    data
  })
}

/**
 * 业务数据中心 大数据分析 能耗分析报表 导出全部（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceBaseStatisticAnalyseExport(data) {
  return request({
    type: 'device',
    url: 'device/base/statistic/analyse/export',
    method: 'post',
    data
  })
}

/**
 * 业务数据中心 大数据分析 能耗分析报表 选择导出（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceBaseStatisticAnalyseOptionExport(data) {
  return request({
    type: 'device',
    url: 'device/base/statistic/analyse/option/export',
    method: 'post',
    data
  })
}

/**
 * 业务数据中心 大数据分析 能耗分析报表 分页（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceBaseStatisticAnalysePageGet(data) {
  return request({
    type: 'device',
    url: 'device/base/statistic/analyse/page/get',
    method: 'post',
    data
  })
}

/**
 * 投诉和评价分析-设备统计列表全部导出
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceBigdataLotListExport(data) {
  return request({
    type: 'device',
    url: 'device/bigdata/lot/list/export',
    method: 'post',
    data
  })
}

/**
 * 物联网监测分析-获取设备统计列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceBigdataLotListGet(data) {
  return request({
    type: 'device',
    url: 'device/bigdata/lot/list/get',
    method: 'post',
    data
  })
}

/**
 * 投诉和评价分析-设备统计列表部分导出
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceBigdataLotListOptionExport(data) {
  return request({
    type: 'device',
    url: 'device/bigdata/lot/list/option/export',
    method: 'post',
    data
  })
}

/**
 * 物联网监测分析-获取在线离线设备数量
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceBigdataLotNumGet(data) {
  return request({
    type: 'device',
    url: 'device/bigdata/lot/num/get',
    method: 'post',
    data
  })
}

/**
 * 根据食堂获取传感器列表参数（cme)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceByDepartmentListGet(data) {
  return request({
    type: 'device',
    url: 'device/by/department/list/get',
    method: 'post',
    data
  })
}

/**
 * 根据食堂和设备子类型获取设备坐标(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceByDeptsubtypeListGet(data) {
  return request({
    type: 'device',
    url: 'device/by/deptsubtype/list/get',
    method: 'post',
    data
  })
}

/**
 * 24小时一氧化碳浓度变化
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceCarbonMonoxide24Get(data) {
  return request({
    type: 'device',
    url: 'device/carbon/monoxide/24/get',
    method: 'post',
    data
  })
}

/**
 * 食安设备详情（ch）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceCollectDeptDetailGet(data) {
  return request({
    type: 'device',
    url: 'device/collect/dept/detail/get',
    method: 'post',
    data
  })
}

/**
 * 食安设备汇总管理（ch）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceCollectDeptGet(data) {
  return request({
    type: 'device',
    url: 'device/collect/dept/get',
    method: 'post',
    data
  })
}

/**
 * 根据食堂获取传感器个数（cme)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceCountGet(data) {
  return request({
    type: 'device',
    url: 'device/count/get',
    method: 'post',
    data
  })
}

/**
 * 设备初始化列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceDefaultList(data) {
  return request({
    type: 'device',
    url: 'device/default/list',
    method: 'post',
    data
  })
}

/**
 * 删除设备
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceDelete(data) {
  return request({
    type: 'device',
    url: 'device/delete',
    method: 'post',
    data
  })
}

/**
 * 获取某时段的平均耗电量和耗水量（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceDeptAverageWaterElectricConsumptionGet(data) {
  return request({
    type: 'device',
    url: 'device/dept/average/water/electric/consumption/get',
    method: 'post',
    data
  })
}

/**
 * 年耗电量
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceDeptElectricYearGet(data) {
  return request({
    type: 'device',
    url: 'device/dept/electric/year/get',
    method: 'post',
    data
  })
}

/**
 * 获取食堂设备在线率（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceDeptOnlineGet(data) {
  return request({
    type: 'device',
    url: 'device/dept/online/get',
    method: 'post',
    data
  })
}

/**
 * 获取某时段的耗电量和耗水量、耗电设备和耗水设备在线率（（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceDeptWaterElectricConsumptionGet(data) {
  return request({
    type: 'device',
    url: 'device/dept/water/electric/consumption/get',
    method: 'post',
    data
  })
}

/**
 * 年耗水量
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceDeptWaterYearGet(data) {
  return request({
    type: 'device',
    url: 'device/dept/water/year/get',
    method: 'post',
    data
  })
}

/**
 * 获取本周常规电器、厨具电器和超大能耗电器的耗电量（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceDeptWeekElectricConsumptionGet(data) {
  return request({
    type: 'device',
    url: 'device/dept/week/electric/consumption/get',
    method: 'post',
    data
  })
}

/**
 * 获取本周各电器的耗电量（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceDeptWeekPerElectricConsumptionGet(data) {
  return request({
    type: 'device',
    url: 'device/dept/week/per/electric/consumption/get',
    method: 'post',
    data
  })
}

/**
 * 获取本周各用水器的耗水量（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceDeptWeekPerWaterConsumptionGet(data) {
  return request({
    type: 'device',
    url: 'device/dept/week/per/water/consumption/get',
    method: 'post',
    data
  })
}

/**
 * 获取本周日常用水、可食净水和矿泉水的耗水量（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceDeptWeekWaterConsumptionGet(data) {
  return request({
    type: 'device',
    url: 'device/dept/week/water/consumption/get',
    method: 'post',
    data
  })
}

/**
 * 设备列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceDeviceList(data) {
  return request({
    type: 'device',
    url: 'device/device/list',
    method: 'post',
    data
  })
}

/**
 * 24小时用电变化
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceElectric24Get(data) {
  return request({
    type: 'device',
    url: 'device/electric/24/get',
    method: 'post',
    data
  })
}

/**
 * 24小时总用电变化
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceElectricAll24Get(data) {
  return request({
    type: 'device',
    url: 'device/electric/all/24/get',
    method: 'post',
    data
  })
}

/**
 * 当日耗电量
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceElectricTodayGet(data) {
  return request({
    type: 'device',
    url: 'device/electric/today/get',
    method: 'post',
    data
  })
}

/**
 * 年耗电量
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceElectricYearGet(data) {
  return request({
    type: 'device',
    url: 'device/electric/year/get',
    method: 'post',
    data
  })
}

/**
 * 获取能耗设备列表（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceEnergyConsumeDeviceListGet(data) {
  return request({
    type: 'device',
    url: 'device/energy/consume/device/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取能耗设备的间隔消耗分析列表（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceEnergyConsumeIntervalMinuterListGet(data) {
  return request({
    type: 'device',
    url: 'device/energy/consume/interval/minuter/list/get',
    method: 'post',
    data
  })
}

/**
 * 二期需求-环境检测（app）（ndj）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceEnvironmentalMonitoring(data) {
  return request({
    type: 'device',
    url: 'device/environmental/monitoring',
    method: 'post',
    data
  })
}

/**
 * 获取冰箱名称下拉表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceFridgeNameOptionListGet(data) {
  return request({
    type: 'device',
    url: 'device/fridge/name/option/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取设备详情
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceGet(data) {
  return request({
    type: 'device',
    url: 'device/get',
    method: 'post',
    data
  })
}

/**
 * 修改设备的报警状态（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceIsenableUpdate(data) {
  return request({
    type: 'device',
    url: 'device/isenable/update',
    method: 'post',
    data
  })
}

/**
 * 获取设备列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceListGet(data) {
  return request({
    type: 'device',
    url: 'device/list/get',
    method: 'post',
    data
  })
}

/**
 * 根据组织ID和类型获取设备列表(liurl)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceListOrgSubtypeGet(data) {
  return request({
    type: 'device',
    url: 'device/list/org/subtype/get',
    method: 'post',
    data
  })
}

/**
 * 24小时甲烷浓度变化
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceMethane24Get(data) {
  return request({
    type: 'device',
    url: 'device/methane/24/get',
    method: 'post',
    data
  })
}

/**
 * 梦象设备-更新分合闸控制状态（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceMxAocnstatus(data) {
  return request({
    type: 'device',
    url: 'device/mx/aocnstatus',
    method: 'post',
    data
  })
}

/**
 * 梦象设备-电能消耗（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceMxEnergyMinuterAnalyse(data) {
  return request({
    type: 'device',
    url: 'device/mx/energy/minuter/analyse',
    method: 'post',
    data
  })
}

/**
 * 梦象设备-分析数据获取（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceMxIntervalDataAnalyse(data) {
  return request({
    type: 'device',
    url: 'device/mx/interval/data/analyse',
    method: 'post',
    data
  })
}

/**
 * 梦象设备-N分钟功率（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceMxPowerMinuterAnalyse(data) {
  return request({
    type: 'device',
    url: 'device/mx/power/minuter/analyse',
    method: 'post',
    data
  })
}

/**
 * 获取设备列表(无分页)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceNopageListGet(data) {
  return request({
    type: 'device',
    url: 'device/nopage/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取设备详情(无token)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceNotokenGet(data) {
  return request({
    type: 'device',
    url: 'device/notoken/get',
    method: 'post',
    data
  })
}

/**
 * 24小时臭氧变化
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceOzone24Get(data) {
  return request({
    type: 'device',
    url: 'device/ozone/24/get',
    method: 'post',
    data
  })
}

/**
 * 获取时间段内食堂的客流量情况（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function devicePeriodPs(data) {
  return request({
    type: 'device',
    url: 'device/period/ps',
    method: 'post',
    data
  })
}

/**
 * 启用/禁用策略
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceStrategyUpdate(data) {
  return request({
    type: 'device',
    url: 'device/strategy/update',
    method: 'post',
    data
  })
}

/**
 * 获取设备绑定的摄像头视频流
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceStream(data) {
  return request({
    type: 'device',
    url: 'device/stream',
    method: 'post',
    data
  })
}

/**
 * 获取晨检机列表（ch）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceTempDeptList(data) {
  return request({
    type: 'device',
    url: 'device/temp/dept/list',
    method: 'post',
    data
  })
}

/**
 * 24小时温湿度变化
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceTemperatureHumidity24Get(data) {
  return request({
    type: 'device',
    url: 'device/temperature/humidity/24/get',
    method: 'post',
    data
  })
}

/**
 * 食堂24小时温湿度变化(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceTemperatureHumidity24GetDept(data) {
  return request({
    type: 'device',
    url: 'device/temperature/humidity/24/get/dept',
    method: 'post',
    data
  })
}

/**
 * 设置温湿度报警温度
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceTemperatureHumidityAlarmUpdate(data) {
  return request({
    type: 'device',
    url: 'device/temperature/humidity/alarm/update',
    method: 'post',
    data
  })
}

/**
 * 设置温湿度运行模式
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceTemperatureHumidityModelUpdate(data) {
  return request({
    type: 'device',
    url: 'device/temperature/humidity/model/update',
    method: 'post',
    data
  })
}

/**
 * 修改设备
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceUpdate(data) {
  return request({
    type: 'device',
    url: 'device/update',
    method: 'post',
    data
  })
}

/**
 * 音量控制(0加1减)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceVoiceControl(data) {
  return request({
    type: 'device',
    url: 'device/voice/control',
    method: 'post',
    data
  })
}

/**
 * 24小时功率变化
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceVoltage24Get(data) {
  return request({
    type: 'device',
    url: 'device/voltage/24/get',
    method: 'post',
    data
  })
}

/**
 * 24小时用水变化
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceWater24Get(data) {
  return request({
    type: 'device',
    url: 'device/water/24/get',
    method: 'post',
    data
  })
}

/**
 * 24小时总用水变化
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceWaterAll24Get(data) {
  return request({
    type: 'device',
    url: 'device/water/all/24/get',
    method: 'post',
    data
  })
}

/**
 * 当日耗水量
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceWaterTodayGet(data) {
  return request({
    type: 'device',
    url: 'device/water/today/get',
    method: 'post',
    data
  })
}

/**
 * 年耗水量
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceWaterYearGet(data) {
  return request({
    type: 'device',
    url: 'device/water/year/get',
    method: 'post',
    data
  })
}

/**
 * 根据食堂获取传感器列表参数(无需User-Id校验)（cme)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceWxByDepartmentListGet(data) {
  return request({
    type: 'device',
    url: 'device/wx/by/department/list/get',
    method: 'post',
    data
  })
}

/**
 * 二期需求-环境检测（微信公众号）（无需User-Id校验）（ndj）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceWxEnvironmentalMonitoring(data) {
  return request({
    type: 'device',
    url: 'device/wx/environmental/monitoring',
    method: 'post',
    data
  })
}

/**
 * 根据食堂获取基础设备和摄像头坐标（食堂预览）(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deviceXyListGet(data) {
  return request({
    type: 'device',
    url: 'device/xy/list/get',
    method: 'post',
    data
  })
}

/**
 * 根据组织ID统计监管设备
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcDeviceCountGet(data) {
  return request({
    type: 'device',
    url: 'pc/device/count/get',
    method: 'post',
    data
  })
}

/**
 * 获取设备列表(地图显示)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcDeviceListGet(data) {
  return request({
    type: 'device',
    url: 'pc/device/list/get',
    method: 'post',
    data
  })
}

/**
 * 报表数据中心-监管设备(导出Excel)（wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcDeviceReportExportMonitorGet(data) {
  return request({
    type: 'device',
    url: 'pc/device/report/export/monitor/get',
    method: 'post',
    data
  })
}

/**
 * 报表数据中心-监管资源统计(导出Excel)（wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcDeviceReportExportResourceGet(data) {
  return request({
    type: 'device',
    url: 'pc/device/report/export/resource/get',
    method: 'post',
    data
  })
}

/**
 * 报表数据中心-监管设备（wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcDeviceReportMonitorGet(data) {
  return request({
    type: 'device',
    url: 'pc/device/report/monitor/get',
    method: 'post',
    data
  })
}

/**
 * 报表数据中心-监管资源统计（wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcDeviceReportResourceGet(data) {
  return request({
    type: 'device',
    url: 'pc/device/report/resource/get',
    method: 'post',
    data
  })
}

/**
 * 根据组织ID统计监管设备资源信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcDeviceResourceCountGet(data) {
  return request({
    type: 'device',
    url: 'pc/device/resource/count/get',
    method: 'post',
    data
  })
}

/**
 * 根据组织ID获取监管设备资源分配信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcDeviceResourcePercentageGet(data) {
  return request({
    type: 'device',
    url: 'pc/device/resource/percentage/get',
    method: 'post',
    data
  })
}

/**
 * 报表数据中心-总体报表-监控设备资源（wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcDeviceTotalreportResourceGet(data) {
  return request({
    type: 'device',
    url: 'pc/device/totalreport/resource/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Device.js